import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import {
  Row,
  Col,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
  Form,
  FormGroup,
  Input,
  Label,
  Button,
  Table,
} from 'reactstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { AuthContext } from '../../context/auth';
import { CampaignContext } from '../../context/campaign';
import toast from 'react-hot-toast';
import { fetchMyCampaign, fetchMyCampaignId } from '~/services/campaign';
import { AdminContext } from '~/context/admin';
import { MyCampaignResponse } from '~/types/campaign';

function AdminNavBar(args) {
  const [loading, setLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [campaignId, setCampaignId] = useState('');
  // Use a ref for synchronous guard against duplicate requests
  const isLoadingRef = useRef(false);
  const [{ campaign }, campaignDispatch] = useContext(CampaignContext);
  const [{ user }, userDispatch] = useContext(AuthContext);
  const [{}, adminDispatch] = useContext(AdminContext);
  const { search, pathname } = useLocation();
  const history = useHistory();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (user?.is_superuser) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }, [user]);

  useEffect(() => {
    const campaign_id = searchParams.get('campaignId');
    // Use ref for synchronous check to prevent duplicate requests
    if (campaign_id && !isLoadingRef.current) {
      setCampaignId(campaign_id);
      loadCampaign(campaign_id);
    }
  }, [searchParams]);

  // const setUrlParams = (campaign_id) => {
  //   const params = new URLSearchParams({ ['campaignId']: campaign_id });
  // };

  const loadCampaign = async (id) => {
    // Synchronous ref check prevents race condition with URL updates
    if (isLoadingRef.current) {
      return;
    }
    
    // Set ref immediately (synchronous) before any async operations
    isLoadingRef.current = true;
    
    try {
      setLoading(true);
      searchParams.set('campaignId', id);
      history.replace({ pathname, search: searchParams.toString() });
      const resp: MyCampaignResponse = await fetchMyCampaignId(id);
      if (resp.detail) {
        if (resp.detail === 'Invalid token.') {
          // Delete localStorage token
          localStorage.removeItem('token');
          history.push('/login');
        } else {
          toast.error(resp.detail);
        }
      } else {
        campaignDispatch({
          type: 'set_campaign',
          payload: resp,
        });
        adminDispatch({
          type: 'set_admin',
          isAdmin: true,
          campaignId: id,
        });
      }
    } catch (e) {
      console.log('getMyCampaign() e: ', e);
      // Show some error here
    } finally {
      setLoading(false);
      isLoadingRef.current = false;
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      loadCampaign(campaignId);
    }
  };

  if (!isAdmin) {
    return <></>;
  }

  return (
    <Navbar {...args}>
      <Row>
        <Col>
          <Label>
            Current Campaign: {campaign?.campaignDetail?.campaign_id}
          </Label>
          <Label>
            Campaign Status: {campaign?.campaignDetail?.campaign_status}
          </Label>
          {loading && `Loading Campaign ...`}
          {campaign && !campaign.patient && !loading && (
            <div className='text-danger fw-bold'>
              No patient assigned to this campaign.
            </div>
          )}
        </Col>
        <Col>
          <Form>
            <Row className='row-cols-lg-auto g-1 align-items-center'>
              <Col>
                <FormGroup floating>
                  <Input
                    id='campaignId'
                    name='campaignId'
                    value={campaignId}
                    onChange={(e) => setCampaignId(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <Label for='campaignId'>Campaign ID</Label>
                </FormGroup>
              </Col>
              <Col>
                <Button
                  color='primary'
                  size='sm'
                  onClick={() => loadCampaign(campaignId)}
                  disabled={!campaignId}
                >
                  Set Campaign
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
        {/* <Col>
            <Label>Quick Reference</Label>
            <Table borderless size='sm'>
              <tbody>
                {refCampaigns.map((opt, i) => {
                  return (
                    <tr key={i}>
                      <td>
                        <Button
                          color='link'
                          size='sm'
                          onClick={() => loadCampaign(opt.value)}
                        >
                          {opt.label}
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col> */}
      </Row>
      {/* <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className='me-auto' navbar>
            <NavItem>
              <NavLink href='/components/'>Components</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href='https://github.com/reactstrap/reactstrap'>
                GitHub
              </NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Options
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>Option 1</DropdownItem>
                <DropdownItem>Option 2</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>Reset</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          <NavbarText>Simple Text</NavbarText>
        </Collapse> */}
    </Navbar>
  );
}

export default AdminNavBar;
